module.exports = __webpack_public_path__ + "static/img/i145.11a0e2c0.png";